import React from "react";
import { Modal, Button } from "react-bootstrap";

const CustomModal = ({
  show,
  onHide,
  title = "Preview",
  content,
  error,
  centered = false,
  size = "lg",
  showFooter = true,
  footerText = "Close"
}) => {
  return (
    <Modal centered={centered} show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <div className="text-danger">{error}</div>
        ) : content ? (
          content
        ) : null}
      </Modal.Body>
      {showFooter && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {footerText}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
